// @flow

import React from 'react';
import { colors } from 'seedling/constants';

type Props = {
  size: string,
};

function AnonymousIcon({ size = '20' }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 8.524C1.5 4.025 4.941.5 9.357.5c4.005 0 7.53 2.793 7.53 6.762 0 .021.03.08.713 1.32.142.255.257.473.36.685.382.78.575 1.406.535 1.98a1.322 1.322 0 00-.002.082c-.003.333-.032.518-.205.768a1.286 1.286 0 01-1 .55 10.326 10.326 0 01-.431.01 14.74 14.74 0 01-.083 1.19c-.114 1.008-.316 1.726-.734 2.15-.579.589-1.268.802-2.578.846v1.918c0 .408-.326.739-.728.739H5.23a.734.734 0 01-.728-.74v-3.98C2.443 13.38 1.5 11.22 1.5 8.524zm15.698 2.648l.028-.002h-.004l-.024.002zm-.869-1.869c.13.237.235.435.326.621.274.56.404.979.385 1.252h-.085a17.682 17.682 0 01-.793-.01c-.42-.016-.765.33-.755.8.006.5-.014 1.122-.08 1.711-.077.679-.215 1.172-.317 1.275-.313.318-.84.428-2.272.42a.734.734 0 00-.732.74v1.91H5.957v-3.65a.742.742 0 00-.357-.635c-1.824-1.099-2.644-2.853-2.644-5.213 0-3.685 2.791-6.545 6.4-6.545 3.269 0 6.073 2.222 6.073 5.283 0 .302.11.586.336 1.022.11.21.599 1.084.563 1.02zm-6.558 3.37c-.376 0-.68.31-.68.69 0 .382.304.69.68.69.374 0 .68-.308.68-.69 0-.38-.306-.69-.68-.69zm-.001-.707a.734.734 0 00.728-.739v-1.018a2.803 2.803 0 002.04-2.711c0-1.551-1.24-2.808-2.768-2.808-1.528 0-2.767 1.257-2.767 2.808 0 .408.326.739.728.739a.734.734 0 00.729-.74A1.32 1.32 0 019.77 6.17a1.32 1.32 0 011.312 1.329 1.32 1.32 0 01-1.312 1.33.734.734 0 00-.728.74v1.659c0 .408.326.74.728.74z"
        fill={colors.mediumGrey}
      />
    </svg>
  );
}

export default AnonymousIcon;
